import { RootState } from 'store';
import { StationCategory } from 'entities/stations';

import { STATE } from '../types/state';

interface IResult {
  [key: string]: StationCategory;
}

const selector = (state: RootState): IResult => {
  const { stationCategories } = state[STATE];
  return stationCategories
    .reduce((acc: IResult, item: StationCategory) => ({
      ...acc,
      [item.code]: item
    }), {});
};

export default selector;
